<template>
    <a :href="href" v-track:click="{ category: 'Outbound', label: href }">
        <slot></slot>
    </a>
</template>
<script>
export default {
    props: ['href'],
}
</script>
